import { jsx as _jsx } from "react/jsx-runtime";
import lodashGet from 'lodash/get';
function formatValueAsHTML(value) {
    if (value) {
        value = value.replaceAll(/(?<value>\d+)/g, '<sub>$<value></sub>');
    }
    return value;
}
export function RenderAsHTML(props) {
    const { data, jpath } = props;
    const value = lodashGet(data, jpath);
    if (!value) {
        return null;
    }
    return (_jsx("div", { 
        // style={styles.info}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: formatValueAsHTML(value),
        } }));
}
